jQuery(window).on("load", function () {
 // setTimeout(function () {
 //    if ($(".rc-container-wrapper").length > 0) {
 //      var subsaveOption = $(
 //        '.rc-container-wrapper .rc-radio.rc-option__subsave input[type="radio"]'
 //      );

 //      if (subsaveOption.length) {
 //        subsaveOption.prop("checked", true).trigger("change").trigger("click");
 //      }
 //    }
 //  }, 2000);
  
  setTimeout(function () {
    if ($(".rc-container-wrapper").length > 0) {
      
       var subsaveOption = $(
        '.rc-container-wrapper .rc-radio.rc-option__subsave input[type="radio"]'
      );
      if (subsaveOption.length) {
        subsaveOption.prop("checked", true).trigger("change").trigger("click");
      }
      var subscription_price = $(
        ".rc-container-wrapper.rc_container_wrapper .rc-radio.rc-option__subsave label[data-label-subsave] span.rc-option__price.rc_widget__price.rc_widget__price--subsave"
      ).html();
     
      var subscription_discount = $(
        ".rc-container-wrapper.rc_container_wrapper .rc-radio.rc-option__subsave label[data-label-subsave] span.rc-option__discount.rc_widget__option__discount"
      ).html();

      if (
        subscription_price != "" &&
        subscription_price != "undefined" &&
        subscription_price != null
      ) {
        $(".recharge-option[data-option-type=subscription] .rc-price").text(
          subscription_price
        );
        $(
          'body[data-template="subscription-layout"] .buttons-wrapper.add-to-cart .subs-atc-inner input[type="submit"]'
        ).val("Add to Cart - " + subscription_price);
        $(
          ".recharge-subscription-widget-container .recharge-grids .recharge-option.rc--active span.rc-box-checkbox input[type=radio]"
        ).attr("data-price", subscription_price);
      }

      if (
        subscription_discount != "" &&
        subscription_discount != "undefined" &&
        subscription_discount != null
      ) {
        $(
          ".recharge-subscription-widget-container .recharge-grids .recharge-option .rc-save-upto .save-percent"
        ).html("Save <br>" + subscription_discount);
      }

      
    }
  }, 2000);


  
});

jQuery(document).ready(function () {
  $(
    ".recharge-subscription-widget-container .recharge-grids .recharge-option span.rc-box-checkbox input[type=radio]"
  ).on("change", function () {
    var purchase_type = $(this).val();
    var subscription_price = $(this).attr("data-price");

    $(
      ".recharge-subscription-widget-container .recharge-grids .recharge-option"
    ).each(function () {
      if ($(this).attr("data-option-type") == purchase_type) {
        $(this).addClass("rc--active");
      } else {
        $(this).removeClass("rc--active");
      }
    });

    if (purchase_type == "subscription") {
      $(this)
        .closest(".w-commerce-commerceaddtocartform")
        .find(
          '.rc-container-wrapper.rc_container_wrapper .rc-template__legacy-radio .rc-radio.rc-option__subsave input[type="radio"]'
        )
        .trigger("click");
      $('.recharge-option[data-option-type="one-time"]')
        .find(".rc-box-bottom")
        .addClass("hideme");
    } else if (purchase_type == "one-time") {
      $(this)
        .closest(".w-commerce-commerceaddtocartform")
        .find(
          '.rc-container-wrapper.rc_container_wrapper .rc-template__legacy-radio .rc-radio.rc-option__onetime input[type="radio"]'
        )
        .trigger("click");
      $(this)
        .closest(".recharge-option")
        .find(".rc-box-bottom")
        .removeClass("hideme");
    }

    if (
      $(
        ".recharge-subscription-widget-container .recharge-grids .recharge-option.rc--active .rc-box-bottom .rc-product-variants"
      ).length == 0
    ) {
      if (
        subscription_price != "" &&
        subscription_price != "undefined" &&
        subscription_price != null
      ) {
        $(
          'body[data-template="subscription-layout"] .buttons-wrapper.add-to-cart .subs-atc-inner input[type="submit"]'
        ).val("Add to Cart - " + subscription_price);
      }
    } else {
      var selected_variant_price = $(
        '.recharge-option[data-option-type="one-time"] .rc-flex-row .rc-col3 .rc-price-grid .rc-price'
      ).text();
      if (
        selected_variant_price != "" &&
        selected_variant_price != "undefined" &&
        selected_variant_price != null
      ) {
        $(
          'body[data-template="subscription-layout"] .buttons-wrapper.add-to-cart .subs-atc-inner input[type="submit"]'
        ).val("Add to Cart - " + selected_variant_price);
      }
    }
  });

  $(
    ".recharge-subscription-widget-container .recharge-grids .recharge-option .rc-box-top .rc-purchase-text"
  ).on("click", function () {
    $(this)
      .closest(".recharge-option")
      .find("span.rc-box-checkbox input[type=radio]")
      .trigger("change");
    $(this)
      .closest(".recharge-option")
      .find("span.rc-box-checkbox input[type=radio]")
      .trigger("click");
  });

  $(".rc-product-variants .product-options-wrapper.buttons").on(
    "click",
    function () {
      var selected_title = $(
        ".rc-product-variants .product-options-wrapper.buttons.w--ecommerce-pill-selected div"
      ).text();
      var selected_price = "";
      var discounted_price = "";
      var subscription_discount = "";
      $("#rc-product-variants-options option").each(function () {
        if ($(this).data("title") === selected_title) {
          selected_price = $(this).data("price");
        }
      });

      subscription_discount = $(
        ".rc-container-wrapper.rc_container_wrapper .rc-radio.rc-option__subsave label[data-label-subsave] span.rc-option__discount.rc_widget__option__discount"
      ).html();
      if (
        subscription_discount != "" &&
        subscription_discount != "undefined" &&
        subscription_discount != null
      ) {
        subscription_discount = subscription_discount.replace("%", "");
      }
      if (
        subscription_discount != "" &&
        subscription_discount != "undefined" &&
        subscription_discount != null &&
        selected_price != "" &&
        selected_price != "undefined" &&
        selected_price != null
      ) {
        discounted_price = parseFloat(
          selected_price -
            parseFloat(
              parseFloat(selected_price) * parseFloat(subscription_discount)
            ) /
              parseFloat(100)
        );
      }

      if (
        discounted_price != "" &&
        discounted_price != "undefined" &&
        discounted_price != null
      ) {
        $(this)
          .closest(".w-commerce-commerceaddtocartform")
          .find('input[name="id"]')
          .attr("data-price", discounted_price);
      }

      $(
        '.recharge-option[data-option-type="one-time"] .rc-flex-row .rc-col3 .rc-price-grid .rc-price'
      ).text("$" + selected_price);
      if (
        selected_price != "" &&
        selected_price != "undefined" &&
        selected_price != null
      ) {
        $(
          'body[data-template="subscription-layout"] .buttons-wrapper.add-to-cart .subs-atc-inner input[type="submit"]'
        ).val("Add to Cart - $" + selected_price);
      }
    }
  );
});
